














































































































import Vue, { PropType } from "vue";

import DateFormatter from "../../shared/DateFormatter";
import Loading from "./Loading.vue";
import { MonthNames } from "../../shared/Month";
import CalendarEventJson from "../../shared/CalendarEventJson";

export default Vue.extend({
  name: "Calendar",
  components: {
    Loading,
  },
  props: {
    dateToShow: {
      type: Date,
      default: null,
    },
    width: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "auto",
    },
    clickableDates: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      MonthNames: MonthNames,
      selectedMonth: null as number | null,
      selectedYear: null as number | null,
      selectedMonthData: null as any[] | null,
    };
  },
  created() {
    this.createCalendar(this.dateToShow);
  },
  methods: {
    createCalendar(setDate: string | null) {
      //setDate in yyyy-mm-dd

      if (setDate == null) {
        var baseDate = new Date();
      } else {
        var baseDate = new Date(setDate);
      }

      var selectedDate = new Date(baseDate);
      selectedDate.setDate(1);

      this.selectedMonth = selectedDate.getMonth();
      this.selectedYear = selectedDate.getFullYear();

      var month = [] as any[];
      var week = { calWeek: null, dates: [] } as {
        calWeek: number | null;
        dates: any[];
      };
      var date = 1;

      //monday first switch
      const weekdays = [6, 0, 1, 2, 3, 4, 5];

      while (week.dates.length < weekdays[selectedDate.getDay()]) {
        week.dates.push(undefined);
      }

      while (baseDate.getMonth() == selectedDate.getMonth()) {
        week.calWeek = DateFormatter.getCalendarWeek(selectedDate);
        week.dates[weekdays[selectedDate.getDay()]] = new Date(selectedDate);

        if (week.dates.length == 7) {
          month.push(week);
          week = { calWeek: null, dates: [] };
        }

        date++;
        selectedDate.setDate(date);
      }

      if (week.dates.length > 0) {
        while (week.dates.length < 7) {
          week.dates.push(undefined);
        }
        month.push(week);
      }

      this.selectedMonthData = month;

      //send back current month and year
      this.$emit("currentYearMonth", this.selectedYear, this.selectedMonth);
    },

    reloadCalendar() {
      this.createCalendar(null);
    },

    getWeekTemplateAreas(week: Date[]) {
      var templateAreaString = '"';

      let day: Date;
      for (day of week) {
        if (day) {
          templateAreaString += "date" + day.getDate() + " ";
        } else {
          templateAreaString += "date0 ";
        }
      }

      templateAreaString += '"';

      return templateAreaString;
    },

    /*
      getEventsAtWeek(calWeek: number): CalendarEventJson[] | undefined {
         if (this.events != null) {
            var eventsAtWeek: CalendarEventJson[]

            function filterByCalWeek(item: any) {
               let beginCalWeek = DateFormatter.getCalendarWeek(new Date(item.beginDateTime))
               let endCalWeek = DateFormatter.getCalendarWeek(new Date(item.endDateTime))

               if(
                  (beginCalWeek <= calWeek && endCalWeek >= calWeek)
                  || (beginCalWeek < calWeek && endCalWeek == calWeek)
                  || (beginCalWeek == calWeek && endCalWeek > calWeek)
               ) {
                  return item
               }
            }

            eventsAtWeek = this.events.filter(filterByCalWeek)

            return eventsAtWeek
         }
      },

      getGridColumn(event: CalendarEventJson, calWeek: number) {
         if(this.selectedMonth != null && this.selectedYear != null) {
            let beginDate = new Date(event.beginDateTime)
            let endDate = new Date(event.endDateTime)

            let firstOfMonth = new Date(this.selectedYear, this.selectedMonth, 1)
            let lastOfMonth = new Date(this.selectedYear, this.selectedMonth+1, 0)

            let beginCalWeek = DateFormatter.getCalendarWeek(beginDate)
            let endCalWeek = DateFormatter.getCalendarWeek(endDate)

            let beginDayDate = beginDate.getDate()
            let endDayDate = endDate.getDate()

            let gridColumnString = ''
            let gridColumnStart = ''
            let gridColumnEnd = ''

            if(beginCalWeek == calWeek && endCalWeek == calWeek) {
               gridColumnStart = 'date' + beginDayDate
               gridColumnEnd = 'date' + endDayDate
            } else if(beginCalWeek == calWeek && endCalWeek > calWeek) {
               gridColumnStart = 'date' + beginDayDate
               gridColumnEnd = '-1'
            } else if(beginCalWeek < calWeek && endCalWeek == calWeek) {
               gridColumnStart = '1'
               gridColumnEnd = 'date' + endDayDate
            } else if(beginCalWeek < calWeek && endCalWeek > calWeek) {
               gridColumnStart = '1'
               gridColumnEnd = '-1'
            }

            if((beginDate.getFullYear() < endDate.getFullYear()) || (beginDate.getMonth() < endDate.getMonth())) {
               if(DateFormatter.getCalendarWeek(firstOfMonth) == calWeek) {
                  gridColumnStart = 'date' + firstOfMonth.getDate()
               } else if(DateFormatter.getCalendarWeek(lastOfMonth) == calWeek) {
                  gridColumnEnd = 'date' + lastOfMonth.getDate()
               }
            }

            gridColumnString = gridColumnStart + ' / ' + gridColumnEnd

            return gridColumnString
         }
      },

      getWeekOverflowStyle(event: CalendarEventJson,  calWeek: number) {
         if(this.selectedMonth != null && this.selectedYear != null) {
            let beginDate = new Date(event.beginDateTime)
            let endDate = new Date(event.endDateTime)

            let firstOfMonth = new Date(this.selectedYear, this.selectedMonth, 1)
            let lastOfMonth = new Date(this.selectedYear, this.selectedMonth+1, 0)

            let beginCalWeek = DateFormatter.getCalendarWeek(new Date(event.beginDateTime))
            let endCalWeek = DateFormatter.getCalendarWeek(new Date(event.endDateTime))

            let classString = ''

            if(beginCalWeek == calWeek && endCalWeek > calWeek) {
               classString = 'end-open'
            } else if(beginCalWeek < calWeek && endCalWeek == calWeek) {
               classString = 'start-open'
            } else if(beginCalWeek < calWeek && endCalWeek > calWeek) {
               classString = 'start-open end-open'
            }

            if((beginDate.getFullYear() < endDate.getFullYear()) || (beginDate.getMonth() < endDate.getMonth())) {
               if(DateFormatter.getCalendarWeek(firstOfMonth) == calWeek) {
                  classString = 'start-open'
               } else if(DateFormatter.getCalendarWeek(lastOfMonth) == calWeek) {
                  classString = 'end-open'
               }
            }

            return classString
         }
      },
      */

    getIsoWeekDates(week: any) {
      var isoWeekDates = JSON.parse(JSON.stringify(week));

      for (let i in week.dates) {
        if (week.dates[i]) {
          isoWeekDates.dates[i] = DateFormatter.formatISODate(week.dates[i]);
        }
      }

      return isoWeekDates;
    },

    calendarShowToday() {
      this.createCalendar(null);
    },

    calendarMonthBefore() {
      if (this.selectedMonth != null && this.selectedYear != null) {
        var newMonth: number;
        var newYear: number;

        if (this.selectedMonth > 0) {
          newMonth = this.selectedMonth - 1;
          newYear = this.selectedYear;
        } else {
          newMonth = 11;
          newYear = this.selectedYear - 1;
        }

        newMonth += 1;
        this.createCalendar(newYear + "-" + (newMonth < 10 ? "0" : "") + newMonth + "-01");
      }
    },

    calendarMonthNext() {
      if (this.selectedMonth != null && this.selectedYear != null) {
        var newMonth: number;
        var newYear: number;

        if (this.selectedMonth < 11) {
          newMonth = this.selectedMonth + 1;
          newYear = this.selectedYear;
        } else {
          newMonth = 0;
          newYear = this.selectedYear + 1;
        }

        newMonth += 1;

        this.createCalendar(newYear + "-" + (newMonth < 10 ? "0" : "") + newMonth + "-01");
      }
    },

    clickedDate(date: Date) {
      if (this.clickableDates) {
        this.$emit("dateClicked", date);
      }
    },
  },

  watch: {
    dateToShow: function () {
      this.createCalendar(this.dateToShow);
    },
  },
});
